











import Vue from 'vue'
import Component from 'vue-class-component'

@Component<AccordionWithTitleDescription>({
  props: {
    accordions: Array
  }
})

export default class AccordionWithTitleDescription extends Vue {
  /**
   * Props variables
   */
  accordions: any

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */


  /**
   * Methods
   */
  formattedText(text: string) {
    return text.replace(/\n/g, '<br>')
  }
}
